/**
 * @class TabTrap
 * @description Trap tabbing within an element
 * @param {HTMLElement | string} selector - The element to trap tabbing within
 * @param {HTMLElement} initialFocus - The element to focus on when the trap is activated
 */
export default class TabTrap {
  constructor(selector, initialFocus = null) {
    this.selector = selector;
    this.focusableElements =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    if (typeof selector === 'string') {
      this.ele = document.querySelector(this.selector);
    } else {
      this.ele = this.selector;
    }
    this.firstFocusableElement = this.ele.querySelectorAll(
      this.focusableElements,
    )[0];
    this.focusableContent = this.ele.querySelectorAll(this.focusableElements);
    this.focusableContent = Array.from(this.focusableContent);
    this.lastFocusableElement =
      this.focusableContent[this.focusableContent.length - 1];
    this.initialFocus = initialFocus;
    this.additionalContent = [];
    this.lastFocusedElement = null;
    this.isOn = false;

    this.update();
  }
  handleKeyDown = (e) => {
    if (e.keyCode === 27) {
      this.off();
      const tabtrapEscapedEvent = new CustomEvent('tabtrapEscaped');
      this.ele.dispatchEvent(tabtrapEscapedEvent);
    }
    let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    if (!isTabPressed) {
      return;
    }
    if (e.shiftKey) {
      if (document.activeElement === this.firstFocusableElement) {
        this.lastFocusableElement?.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === this.lastFocusableElement) {
        this.firstFocusableElement?.focus();
        e.preventDefault();
      }
    }
  };
  update = (focusableElements = null) => {
    if (focusableElements) {
      this.focusableElements = focusableElements;
    }
    this.firstFocusableElement = this.ele.querySelectorAll(
      this.focusableElements,
    )[0];
    this.focusableContent = this.ele.querySelectorAll(this.focusableElements);
    this.focusableContent = Array.from(this.focusableContent);
    this.additionalContent.forEach((element) => {
      this.focusableContent.push(element);
    });
    this.lastFocusableElement =
      this.focusableContent[this.focusableContent.length - 1];

    this.focusableContent.forEach((element) => {
      element._parentTabTrap = this;
      element.dataset.test = 'test';
      // console.log(element);
      // console.log(element._parentTabTrap);
    })
  };
  addElement = (element) => {
    this.additionalContent.push(element);
    this.update();
  };
  incrementTabIndexes = () => {
    this.focusableContent.forEach((element, i) => {
      element.setAttribute('tabindex', i + 1);
    });
  };
  removeTabIndexes = () => {
    this.focusableContent.forEach((element, i) => {
      element.setAttribute('tabindex', '-1');
    });
  };

  on = () => {
    this.lastFocusedElement = document.activeElement;

    if (this.lastFocusedElement._parentTabTrap && typeof this.lastFocusedElement._parentTabTrap.off === 'function') {
      this.lastFocusedElement._parentTabTrap.off();
    }

    this.incrementTabIndexes();
    document.addEventListener('keydown', this.handleKeyDown);

    if (this.initialFocus) {
      this.initialFocus?.focus();
    } else {
      this.firstFocusableElement?.focus();
    }

    this.isOn = true;
  };

  off = () => {
    this.removeTabIndexes();
    document.removeEventListener('keydown', this.handleKeyDown);

    if (this.lastFocusedElement) {
      if (this.lastFocusedElement._parentTabTrap && typeof this.lastFocusedElement._parentTabTrap.on === 'function') {

        this.lastFocusedElement._parentTabTrap.on();
      } else {
        this.lastFocusedElement?.focus();
      }
      this.lastFocusedElement = null;
    }

    this.isOn = false;
  };
}
